import { PROVIDER_NAMES } from '~/composables/analytics/providers/constants'

const providerFormatters = {
  [PROVIDER_NAMES.META_PIXEL]: (baseEventName, env, props) => {
    const eventName = props?.event_name
    const formattedName = addEnvironmentSuffix(baseEventName, env)
    return eventName ? `[${eventName}]_${formattedName}` : formattedName
  },
  [PROVIDER_NAMES.POSTHOG]: (baseEventName, env, props) => {
    return baseEventName
  },
}

/**
 * Formats event name according to provider-specific rules
 *
 * @param {object} config - Configuration object
 * @param {string} config.baseEventName - The base event name (e.g., 'CadastroIniciado')
 * @param {string} config.env - The environment string (e.g., 'Production', 'Staging')
 * @param {object} config.props - Event properties that may contain event_name
 * @param {string} config.provider - The analytics provider name from PROVIDER_NAMES
 *
 * @returns {string} Formatted event name according to provider rules
 */
export function formatEventName({
  baseEventName,
  env,
  props = {},
  provider = PROVIDER_NAMES.META_PIXEL,
}) {
  const formatter = providerFormatters[provider]

  if (!formatter) {
    return addEnvironmentSuffix(baseEventName, env)
  }

  return formatter(baseEventName, env, props)
}

/**
 * Adds environment suffix to event name if not Production
 * @param {string} baseEventName - The base event name
 * @param {string} env - The environment string
 * @returns {string} Event name with environment suffix (if not Production)
 */
function addEnvironmentSuffix(baseEventName, env) {
  return env === 'Production' ? baseEventName : `${baseEventName}_${env}`
}
